import { Fragment } from 'react';
import pick from 'lodash/pick';
import moment from 'moment/moment';

import { ProcessTaskAssignEnum, ProcessTaskTypesEnum } from '@thinknet-gmbh/platform-common';

import { Loader } from '@thinknet-gmbh/platform-common-ui';

import { useGetCurrentAccount } from 'src/hooks/accounts/get-current-account.hook';
import { useGetProcessTask } from 'src/hooks/process-tasks/get-process-task.hook';
import { useCreateProcessTask } from 'src/hooks/process-tasks/create-process-task.hooks';
import { useUpdateProcessTask } from 'src/hooks/process-tasks/update-process-task.hook';

import { getDueToDays } from '../../../../task-manager.helpers';

import { TaskForm } from './components/task-form';
import { TaskEditForm } from './components/task-edit-form';

import { IProcessTask } from '../../../../task-manager.interfaces';

const ChangeTask = ({ id, onClose }: { id?: string; onClose: () => void }) => {
  const { processTask, loading } = useGetProcessTask(id);
  const { createProcessTask, loading: createLoading } = useCreateProcessTask({
    onSuccess: onClose,
  });
  const { updateProcessTask, loading: updateLoading } = useUpdateProcessTask({
    onSuccess: onClose,
  });

  const { account } = useGetCurrentAccount();

  const { _id } = processTask || {};

  const isEdit = processTask?._id;

  const initialValue = {
    ...pick(processTask, [
      'title',
      'details',
      'status',
      'responsiblePersonsIds',
      'jobId',
      'type',
      'companyId',
      'departmentId',
      'checklist',
      'assignTo',
      'description',
      'createdBy',
    ]),
    ...(processTask.dueTo && {
      dueTo: moment(processTask.dueTo),
      dueDays: getDueToDays(processTask.dueTo),
    }),
  };

  const onCreateTask = (values: IProcessTask) => {
    createProcessTask({
      variables: {
        payload: {
          type: ProcessTaskTypesEnum.MANUALLY,
          ...values,
        },
      },
    });
  };

  const onUpdateTask = (values: IProcessTask) => {
    updateProcessTask({
      variables: {
        payload: {
          _id,
          ...values,
        },
      },
    });
  };

  if (loading) return <Loader />;

  return (
    <Fragment>
      {isEdit ? (
        <TaskEditForm
          onCancel={onClose}
          loading={updateLoading}
          onSubmit={onUpdateTask}
          initialValue={initialValue}
          accountId={account._id}
        />
      ) : (
        <TaskForm
          initialValue={{
            assignTo: ProcessTaskAssignEnum.PERSONS,
            createdBy: account?._id,
            type: ProcessTaskTypesEnum.MANUALLY,
          }}
          onCancel={onClose}
          loading={createLoading}
          onSubmit={onCreateTask}
        />
      )}
    </Fragment>
  );
};

export default ChangeTask;
